// extracted by mini-css-extract-plugin
export default {"btnBlue":"OrdersList_btnBlue__Wz5Ni","scrollBox":"OrdersList_scrollBox__A4M4n","spinner":"OrdersList_spinner__H27kH"};